import { SxProps, Theme } from '@mui/material'

export const msxs = (...sxs: Array<SxProps | SxProps<Theme> | undefined>): SxProps => {
    const validStyles = sxs.filter((sx): sx is SxProps => sx !== undefined)
    return Object.assign({}, ...validStyles)
}
